import React from "react";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../../../../../../Services/axiosCommon";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
import Dasboard from "../../../../../../Components/Icons/Dasboard";
import * as yup from "yup";
import { notification } from "antd";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import { NuDate, NuInput, NuLabel, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";

export default function CreateInvoiceOut({ data }) {
    const {officeId,proJectId} = useParams();
    const {value:Status ,getData:refOutgoingStatus} = useFetchMataData(`/dropdown/dropdown-details/`,'OutgoingStatus')
  
  // const { value: Status } = useFetchMataData(`/Metadata/noteStatus`);
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);

  const [createNew, setCreateNew] = useState({
    proJectId: "",
    type:"outgoing",
    invoice_no:"",
    date: NuDate({ value: new Date(), format: "YYYY-MM-DD" }),
    submittedOn: NuDate({ value: new Date(), format: "YYYY-MM-DD" }),
    amount: "",
    receivedAmount: "",
    status: "",
    description: "",
    comments: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: yup.object({
    //   title: yup.string().required("Title is Required"),
    //   status: yup.string().required("Please Select Status"),
    }),
    onSubmit: async (value) => {
      setIsLoading(true);

      data
        ? axios
            .put(`/payments/${data?.paymentId}`, value)
            .then((res) => {
              if (res.data.status == true) {
                setIsLoading(false);
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " created",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "creation failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "creation failed",
                placement: "bottomRight",
              });
            })
        : axios
            .post("/payments/", value)
            .then((res) => {
              if (res.data.status == true) {
                setIsLoading(false);
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " created",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "creation failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "creation failed",
                placement: "bottomRight",
              });
            });
    },
  });

  async function getProject() {
    await axios
      .get(`/DropDown/${proJectId}/getAllProjects`)
      .then(async (res) => {
        let list = res?.data?.data || [];
        let finalData = [];
        (await res?.data?.data) &&
          list.map((item, idx) => {
            finalData.push({
              value: item.projId,
              label: item.projName,
            });
          });
        setProjectList(finalData);

        // await res?.data?.Project && setTotalProject(res?.data?.totalProject);
        // console.log('====',res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    getProject();
  }, []);

  return (
    <div className="w-full mx-auto py-2 px-4 ">
      {contextHolder}
      <div className="md:flex justify-end w-full">
      {/* <Breadcrumb 
      items={[

        { name: "Finance" },
           
        {
          name: "Outgoing",
          link: `/project/payments/invoice-out/${officeId}/${proJectId}`
        },

        { name: "Create" },
      ]} 
            /> */}
        {/* <Breadcrumb
          items={[
            {
              title: (
                <Link to="/dashboard">
                  <Dasboard color="gray" width={10} height={10} />{" "}
                </Link>
              ),
            },
            {
              title: (
                <Link to="/payments/invoice-in">
                  <p className=" text-[12px] ">Finance</p>
                </Link>
              ),
            },
            {
              title: (
                <Link to="/payments/invoice-out">
                  <p className=" text-[12px] ">Outgoing</p>
                </Link>
              ),
            },
            { title: <p className=" text-[12px] ">Create</p> },
          ]}
        /> */}

        <div className=" flex gap-2 items-center mr-6">
          <BackButton />
        </div>
      </div>
      <div>
        <div
          className=" w-full mx-auto h-[85%] bg-white rounded-[6px] mt-2"
          // style={{ border: "1px solid #C5C5C5" }}
        >
          <form onSubmit={formik.handleSubmit}>
            <div className=" w-full flex justify-between items-center">
              <NuLabel label="Outgoing" />
              {/* <BackButton /> */}
            </div>
            <div className="flex flex-wrap justify-start">
              <FormikSelectTwo
                label="Project"
                Options={projectList || []}
                formik={formik}
                placeholder="Choose"
                name="proJectId"
                width="w-full md:w-1/3"
                isRequired={true}
              />
              <NuInput
                           type="text"

                 label="Invoice No"
                 formik={formik}
                 placeholder="Invoice No"
                 name="invoice_no"
                 width="w-full md:w-1/3"
                 isRequired={true}
                />
              <NuInput
                           type="number"

                label="Amount"
                formik={formik}
                placeholder="Amount"
                name="amount"
                width="w-full md:w-1/3"
                isRequired={true}
              />

              <NuInput
                           type="number"

                label="Paid Amount"
                formik={formik}
                placeholder="Paid Amount"
                name="receivedAmount"
                width="w-full md:w-1/3"
                isRequired={true}
              />
                <NuInput
                             type="text"

                 label="Description"
                 formik={formik}
                 placeholder="Description"
                 name="description"
                 width="w-full md:w-1/3"
                 isRequired={true}
                />
              <NuDate
                label="Due Date"
                formik={formik}
                name="date"
                width=" w-full md:w-1/3"
              />

              <NuDate
                label="Submitted On"
                formik={formik}
                name="submittedOn"
                width=" w-full md:w-1/3"
              />
              <FormikSelectTwo
                label="Status"
                Options={Status}
                formik={formik}
                placeholder="Choose"
                name="status"
                width="w-full md:w-1/3"
                getFunc={refOutgoingStatus}
                  displayProperty={"Status"}
                  propertyName={"OutgoingStatus"}
                isRequired={true}
              />

              <NuTextArea
                label="Comments"
                placeholder="Comments"
                formik={formik}
                name="comments"
                width="w-full md:w-2/3"
              />
            </div>

            <div className="flex justify-between items-center">
                                      <div className="w-1/2">
                        
                                      </div>
                        
                                      <div
                                        className=" mr-2 rounded-md"
                                        style={{ border: "1px solid #C5C5C5" }}
                                      >
                        
                                      </div>
                                      <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
                                      <CancelButton handleClick={() => navigate(-1)} />
                                      <SubmitButton isLoading={isLoading} />
                                    </div>
                                    </div>
          </form>
        </div>
      </div>
    </div>
  );
}
